import Api from '@/services/Api'
import MetodosGlobais from '@/utils/MetodosGlobais'

const RECURSO = '/metadados'
const DISTRIBUICAO = 'meiosDeDistribuicao'
const REPRESENTACAO = 'meiosDeRepresentacao'
const ORGAOSRESPONSAVEIS = 'orgaosResponsaveis'
const PERIODICIDADE = 'periodicidades'
const CARGAS = 'cargas'
const DADOS = 'dados'

export default {
  GetMeiosDeDistribuicao,
  PostMeiosDeDistribuicao,
  PutMeiosDeDistribuicao,
  DeleteMeiosDeDistribuicao,

  GetMeiosDeRepresentacao,
  PostMeiosDeRepresentacao,
  PutMeiosDeRepresentacao,
  DeleteMeiosDeRepresentacao,

  GetOrgaosResponsaveis,
  PostOrgaosResponsaveis,
  PutOrgaosResponsaveis,
  DeleteOrgaosResponsaveis,

  GetPeriodicidade,
  PostPeriodicidade,
  PutPeriodicidade,
  DeletePeriodicidade,

  GetCargas,
  PostCargas,
  PutCargas,
  DeleteCargas,

  GetDados,
  PostDados,
  PutDados,
  DeleteDados,

}

// MeiosDeDistribuicao
function GetMeiosDeDistribuicao (id) {
  let params = { 'id': id }
  return Api.get(`${RECURSO}/${DISTRIBUICAO}${MetodosGlobais.createEncodeQuery(params)}`)
};

function PostMeiosDeDistribuicao (payload) {
  const params = {meio_distribuicao: payload.meio_distribuicao}
  return Api.post(`/metadados/meiosDeDistribuicao`, params)
};

function PutMeiosDeDistribuicao (id, payload) {
  return Api.put(`${RECURSO}/${DISTRIBUICAO}/${id}`, payload)
};

function DeleteMeiosDeDistribuicao (id) {
  let params = { 'id': id }
  return Api.delete(`${RECURSO}/${DISTRIBUICAO}/${MetodosGlobais.createEncodeQuery(params)}`)
};

// MeiosDeRepresentacao
function GetMeiosDeRepresentacao (id) {
  let params = { 'id': id }
  return Api.get(`${RECURSO}/${REPRESENTACAO}/${MetodosGlobais.createEncodeQuery(params)}`)
};

function PostMeiosDeRepresentacao (payload) {
  const params = {meio_representacao: payload.meio_representacao}
  return Api.post(`${RECURSO}/${REPRESENTACAO}`, payload)
};

function PutMeiosDeRepresentacao (payload) {
  return Api.put(`${RECURSO}/${REPRESENTACAO}/${payload.id}`, payload)
};

function DeleteMeiosDeRepresentacao (id) {
  let params = { 'id': id }
  return Api.delete(`${RECURSO}/${REPRESENTACAO}/${MetodosGlobais.createEncodeQuery(params)}`)
};

// ==========================================================================
// Recurso: orgaosResponsaveis
// Privilégio: METADADOS_ORGAOS_RESPONSAVEIS_CRUD (Já cadastrado no BD)
// url exemplo: smitgbc031:55360/api/v1/metadados/orgaosResponsaveis
// Métodos aceitos: GET,POST,PUT,DELETE
// Exemplos de chamadas e retornos:

// Listar todos os órgãos responsáveis
// GET smitgbc031:55360/api/v1/metadados/orgaosResponsaveis
// Retorna a lista JSON de todos os orgãos responsáveis cadastrados. Ex.:
// [
// 		{
//             "id": 1,
//             "orgao": "Secretaria Municipal de Educação",
//             "sigla": "SME"
//         },
//         {
//             "id": 2,
//             "orgao": "Secretaria Municipal da Saúde",
//             "sigla": "SMS"
//         }
// ]

// Buscar um órgão responsável específico
// GET smitgbc031:55360/api/v1/metadados/orgaosResponsaveis/{id}
// Retorna a lista JSON com o órgão responsável buscado. Ex. Usando id 1 na request:
// [
// 		{
//             "id": 1,
//             "orgao": "Secretaria Municipal de Educação",
//             "sigla": "SME"
//         }
// ]

// Adicionar um novo órgão responsável (conteúdo JSON no Body)
// POST smitgbc031:55360/api/v1/metadados/orgaosResponsaveis

// {
// 	"orgao": "Secretaria Municipal de TESTE",
// 	"sigla": "TESTE"
// }

// Retorna o meio de distribuição adicionado já com o ID. Ex.:
// [
// 	{
// 	  "id":5,
// 	  "orgao": "Secretaria Municipal de TESTE",
// 	  "sigla": "TESTE"
// 	}
// ]

// Alterar um órgão responsável (conteúdo JSON no Body)
// PUT smitgbc031:55360/api/v1/metadados/orgaosResponsaveis/{id}
// {
//   	"orgao": "Secretaria Municipal de TESTE2",
// 	"sigla": "TESTE2"
// }

// Retorna a confirmação da alteração para o id escolhido

// Apagar órgão responsável
// DELETE smitgbc031:55360/api/v1/metadados/orgaosResponsaveis/{id}

// Retorna a confirmação da exclusão para o id escolhido.
// ==========================================================================
function GetOrgaosResponsaveis (id) {
  let params = { 'id': id }
  return Api.get(`${RECURSO}/${ORGAOSRESPONSAVEIS}/${MetodosGlobais.createEncodeQuery(params)}`)
};

function PostOrgaosResponsaveis (payload) {
  return Api.post(`${RECURSO}/${ORGAOSRESPONSAVEIS}/`, payload)
};

function PutOrgaosResponsaveis (payload) {
  return Api.put(`${RECURSO}/${ORGAOSRESPONSAVEIS}/${payload.id}`, payload)
};

function DeleteOrgaosResponsaveis (id) {
  let params = { 'id': id }
  return Api.delete(`${RECURSO}/${ORGAOSRESPONSAVEIS}/${MetodosGlobais.createEncodeQuery(params)}`)
};

// Recurso: periodicidades
// Privilégio: METADADOS_PERIODICIDADES_CRUD (Já cadastrado no BD)
// url exemplo: smitgbc031:55360/api/v1/metadados/periodicidades
// Métodos aceitos: GET,POST,PUT,DELETE
// Exemplos de chamadas e retornos:

// Listar todas as periodicidades
// GET smitgbc031:55360/api/v1/metadados/periodicidades
// Retorna a lista JSON de todas as periodicidades cadastradas. Ex.:
// [
// 		{
//             "id": 1,
//             "periodicidade": "diários"
//         },
//         {
//             "id": 2,
//             "periodicidade": "semanais"
//         }
// ]

// Buscar uma periodicidade específica
// GET smitgbc031:55360/api/v1/metadados/periodicidades/{id}
// Retorna a lista JSON com a periodicidade buscada. Ex. Usando id 1 na request:
// [
// 		{
//             "id": 1,
//             "periodicidade": "diários"
//         }
// ]

// Adicionar uma nova periodicidade (conteúdo JSON no Body)
// POST smitgbc031:55360/api/v1/metadados/periodicidades

// {
// 	"periodicidade": "teste"
// }

// Retorna a periodicidade adicionada já com o ID. Ex.:
// [
// 	{
// 	  "id":15,
// 	  "periodicidade": "teste"
// 	}
// ]

// Alterar uma periodicidade (conteúdo JSON no Body)
// PUT smitgbc031:55360/api/v1/metadados/periodicidades/{id}
// {
// 	"periodicidade": "teste"
// }

// Retorna a confirmação da alteração para o id escolhido

// Apagar periodicidade
// DELETE smitgbc031:55360/api/v1/metadados/periodicidades/{id}

// Retorna a confirmação da exclusão para o id escolhido.

// ==========================================================================

function GetPeriodicidade (id) {
  let params = { 'id': id }
  return Api.get(`${RECURSO}/${PERIODICIDADE}/${MetodosGlobais.createEncodeQuery(params)}`)
};

function PostPeriodicidade (payload) {
  return Api.post(`${RECURSO}/${PERIODICIDADE}/`, payload)
};

function PutPeriodicidade (payload) {
  return Api.put(`${RECURSO}/${PERIODICIDADE}/${payload.id}`, payload)
};

function DeletePeriodicidade (id) {
  let params = { 'id': id }
  return Api.delete(`${RECURSO}/${PERIODICIDADE}/${MetodosGlobais.createEncodeQuery(params)}`)
};

// Recurso: cargas
// Privilégio: METADADOS_CARGAS_CRUD (Já cadastrado no BD)
// url exemplo: smitgbc031:55360/api/v1/metadados/cargas
// Métodos aceitos: GET,POST,PUT,DELETE
// Exemplos de chamadas e retornos:

// Listar todas as cargas
// GET smitgbc031:55360/api/v1/metadados/cargas
// Retorna a lista JSON de todas as cargas cadastradas. Ex.:
// [
// 	{
// 		"id": 1,
// 		"nome_dag": "sme_etl_filacreche_matriculas",
// 		"data_hora_ultima_carga": "2021-07-20 02:00:35",
// 		"periodicidade_carga": {
// 			"id": 1,
// 			"periodicidade": "diários"
// 		},
// 		"orgao_responsavel": {
// 			"id": 1,
// 			"orgao": "Secretaria Municipal de Educação",
// 			"sigla": "SME"
// 		}
// 	},
// 	{
// 		"id": 2,
// 		"nome_dag": "sme_etl_tmaAnualFilaCreche",
// 		"data_hora_ultima_carga": "2021-05-10 17:04:59",
// 		"periodicidade_carga": {
// 			"id": 3,
// 			"periodicidade": "mensais"
// 		},
// 		"orgao_responsavel": {
// 			"id": 1,
// 			"orgao": "Secretaria Municipal de Educação",
// 			"sigla": "SME"
// 		}
// 	}
// ]

// Buscar uma carga específica
// GET smitgbc031:55360/api/v1/metadados/cargas/{id}
// Retorna a lista JSON com a carga buscada. Ex. Usando id 1 na request:
// [
// 	{
// 		"id": 1,
// 		"nome_dag": "sme_etl_filacreche_matriculas",
// 		"data_hora_ultima_carga": "2021-07-20 02:00:35",
// 		"periodicidade_carga": {
// 			"id": 1,
// 			"periodicidade": "diários"
// 		},
// 		"orgao_responsavel": {
// 			"id": 1,
// 			"orgao": "Secretaria Municipal de Educação",
// 			"sigla": "SME"
// 		}
// 	},
// ]

// Adicionar uma nova carga (conteúdo JSON no Body)
// POST smitgbc031:55360/api/v1/metadados/cargas
// ** O campo "data_hora_ultima_carga" não é obrigatório, mas pode ser interessante para fazer as pegadinhas do malandro. Caso não seja passado, irá com valor nulo no banco **
// {
// 	"nome_dag": "teste_etl_cargaTeste",
// 	"data_hora_ultima_carga": "2021-07-14 02:00:34",
// 	"periodicidade_carga": {
// 		"id": 1
// 	},
// 	"orgao_responsavel": {
// 		"id": 2
// 	}
// }

// Retorna a carga adicionada já com o ID. Ex.:
// [
// 	{
// 		"id": 32,
// 		"nome_dag": "teste_etl_cargaTeste",
// 		"data_hora_ultima_carga": "2021-07-14 02:00:34",
// 		"periodicidade_carga": {
// 			"id": 1,
// 			"periodicidade": "diários"
// 		},
// 		"orgao_responsavel": {
// 			"id": 2,
// 			"orgao": "Secretaria Municipal da Saúde",
// 			"sigla": "SMS"
// 		}
// 	}
// ]

// Alterar uma carga (conteúdo JSON no Body)
// PUT smitgbc031:55360/api/v1/metadados/cargas/{id}
// ** se não enviar o campo "data_hora_ultima_carga", o valor será nulo **
// {
// 	"nome_dag": "teste_etl_cargaTeste",
// 	"data_hora_ultima_carga": "2021-07-14 02:00:34",
// 	"periodicidade_carga": {
// 		"id": 1
// 	},
// 	"orgao_responsavel": {
// 		"id": 2
// 	}
// }

// Retorna a confirmação da alteração para o id escolhido

// Apagar carga
// DELETE smitgbc031:55360/api/v1/metadados/cargas/{id}

// Retorna a confirmação da exclusão para o id escolhido.

// ==========================================================================

function GetCargas (id) {
  let params = { 'id': id }
  return Api.get(`${RECURSO}/${CARGAS}/${MetodosGlobais.createEncodeQuery(params)}`)
};

function PostCargas (payload) {
  if(payload && payload.id) delete payload.id
  return Api.post(`${RECURSO}/${CARGAS}`, payload)
};

function PutCargas (payload) {
  return Api.put(`${RECURSO}/${CARGAS}/${payload.id}`, payload)
};

function DeleteCargas (id) {
  let params = { 'id': id }
  return Api.delete(`${RECURSO}/${CARGAS}/${MetodosGlobais.createEncodeQuery(params)}`)
};

// Recurso: dados
// Privilégio: METADADOS_DADOS_CRUD (Já cadastrado no BD)
// url exemplo: smitgbc031:55360/api/v1/metadados/dados
// Métodos aceitos: GET,POST,PUT,DELETE
// Exemplos de chamadas e retornos:

// Listar todos os dados
// GET smitgbc031:55360/api/v1/metadados/dados
// Retorna a lista JSON de todos os dados cadastrados. Ex.:
// [
// 	{
// 		"id": 1,
// 		"nome_dado": "FILA_CRECHE",
// 		"descricao_dado": "Dados da fila da creche",
// 		"fonte_dado": "Coordenadoria de TIC",
// 		"local_distribuicao": "https://hom-cieduapi.sme.prefeitura.sp.gov.br/sp360/fila_creche/",
// 		"formato_nome": null,
// 		"nome_arquivo_ultima_importacao": null,
// 		"data_arquivo_ultima_importacao": "2021-07-20",
// 		"data_referencia_ultima_importacao": "2021-07-19",
// 		"data_hora_ultima_importacao": "2021-07-20 02:00:29",
// 		"periodicidade_dado": {
// 			"id": 1,
// 			"periodicidade": "diários"
// 		},
// 		"meio_representacao": {
// 			"id": 1,
// 			"meio_representacao": "JSON"
// 		},
// 		"meio_distribuicao": {
// 			"id": 1,
// 			"meio_distribuicao": "Web API"
// 		},
// 		"carga": {
// 			"id": 1,
// 			"nome_dag": "sme_etl_filacreche_matriculas"
// 		}
// 	},
// 	{
// 		"id": 2,
// 		"nome_dado": "MATRICULAS",
// 		"descricao_dado": "Dados de Matrículas",
// 		"fonte_dado": "Coordenadoria de TIC",
// 		"local_distribuicao": "https://hom-cieduapi.sme.prefeitura.sp.gov.br/sp360/matriculas/",
// 		"formato_nome": null,
// 		"nome_arquivo_ultima_importacao": null,
// 		"data_arquivo_ultima_importacao": "2021-07-20",
// 		"data_referencia_ultima_importacao": "2021-07-19",
// 		"data_hora_ultima_importacao": "2021-07-20 02:00:29",
// 		"periodicidade_dado": {
// 			"id": 1,
// 			"periodicidade": "diários"
// 		},
// 		"meio_representacao": {
// 			"id": 1,
// 			"meio_representacao": "JSON"
// 		},
// 		"meio_distribuicao": {
// 			"id": 1,
// 			"meio_distribuicao": "Web API"
// 		},
// 		"carga": {
// 			"id": 1,
// 			"nome_dag": "sme_etl_filacreche_matriculas"
// 		}
// 	}
// ]

// Buscar um dado específico
// GET smitgbc031:55360/api/v1/metadados/dados/{id}
// Retorna a lista JSON com o dado buscado. Ex. Usando id 1 na request:
// [
// 	{
// 		"id": 1,
// 		"nome_dado": "FILA_CRECHE",
// 		"descricao_dado": "Dados da fila da creche",
// 		"fonte_dado": "Coordenadoria de TIC",
// 		"local_distribuicao": "https://hom-cieduapi.sme.prefeitura.sp.gov.br/sp360/fila_creche/",
// 		"formato_nome": null,
// 		"nome_arquivo_ultima_importacao": null,
// 		"data_arquivo_ultima_importacao": "2021-07-20",
// 		"data_referencia_ultima_importacao": "2021-07-19",
// 		"data_hora_ultima_importacao": "2021-07-20 02:00:29",
// 		"periodicidade_dado": {
// 			"id": 1,
// 			"periodicidade": "diários"
// 		},
// 		"meio_representacao": {
// 			"id": 1,
// 			"meio_representacao": "JSON"
// 		},
// 		"meio_distribuicao": {
// 			"id": 1,
// 			"meio_distribuicao": "Web API"
// 		},
// 		"carga": {
// 			"id": 1,
// 			"nome_dag": "sme_etl_filacreche_matriculas"
// 		}
// 	}
// ]

// Adicionar um novo dado (conteúdo JSON no Body)
// POST smitgbc031:55360/api/v1/metadados/dados
// ** Os campos "formato_nome", "nome_arquivo_ultima_importacao", "data_arquivo_ultima_importacao", "data_referencia_ultima_importacao" e "data_hora_ultima_importacao" não são obrigatórios, se não forem passados, terão o valor nulo **
// {
// 	"nome_dado": "TESTE_COMPLETO_TESTES",
// 	"descricao_dado": "Dados de TESTE completo de todos os TESTES",
// 	"fonte_dado": "Coordenadoria TESTE",
// 	"local_distribuicao": "nas.prodam\\NID\\BASES\\TESTE",
// 	"formato_nome": "TESTE_YYYYMMDD",
// 	"nome_arquivo_ultima_importacao": "20210719.csv",
// 	"data_arquivo_ultima_importacao": "2021-07-19",
// 	"data_referencia_ultima_importacao": "2021-06-19",
// 	"data_hora_ultima_importacao": "2021-07-20 03:45:10",
// 	"periodicidade_dado": {
// 		"id": 2
// 	},
// 	"meio_representacao": {
// 		"id": 2
// 	},
// 	"meio_distribuicao": {
// 		"id": 4
// 	},
// 	"carga": {
// 		"id": 3
// 	}
// }

// Retorna o dado adicionado já com o ID. Ex.:
// [
// 	{
// 		"id": 42,
// 		"nome_dado": "TESTE_COMPLETO_TESTES",
// 		"descricao_dado": "Dados de TESTE completo de todos os TESTES",
// 		"fonte_dado": "Coordenadoria TESTE",
// 		"local_distribuicao": "nas.prodam\\NID\\BASES\\TESTE",
// 		"periodicidade_dado": {
// 			"id": 2,
// 			"periodicidade": "semanais"
// 		},
// 		"meio_representacao": {
// 			"id": 2,
// 			"meio_representacao": "CSV"
// 		},
// 		"meio_distribuicao": {
// 			"id": 4,
// 			"meio_distribuicao": "SMB"
// 		},
// 		"carga": {
// 			"id": 3,
// 			"nome_dag": "sms_etl_filaEspera"
// 		},
// 		"formato_nome": "TESTE_YYYYMMDD",
// 		"nome_arquivo_ultima_importacao": "20210719.csv",
// 		"data_arquivo_ultima_importacao": "2021-07-19",
// 		"data_referencia_ultima_importacao": "2021-06-19",
// 		"data_hora_ultima_importacao": "2021-07-20 03:45:10"
// 	}
// ]

// Alterar um dado (conteúdo JSON no Body)
// PUT smitgbc031:55360/api/v1/metadados/dados/{id}
// ** se não enviar os campos (não obrigatórios) "formato_nome", "nome_arquivo_ultima_importacao", "data_arquivo_ultima_importacao", "data_referencia_ultima_importacao" e "data_hora_ultima_importacao" o valor será nulo **

// {
// 	"nome_dado": "TESTE_COMPLETO_TESTES_2",
// 	"descricao_dado": "Dados de TESTE completo de todos os TESTES_2",
// 	"fonte_dado": "Coordenadoria TESTE_2",
// 	"local_distribuicao": "nas.prodam\\NID\\BASES\\TESTE_2",
// 	"formato_nome": "TESTE_YYYYMMDD",
// 	"nome_arquivo_ultima_importacao": "20210719.csv",
// 	"data_arquivo_ultima_importacao": "2021-07-19",
// 	"data_referencia_ultima_importacao": "2021-06-19",
// 	"data_hora_ultima_importacao": "2021-07-20 03:45:10",
// 	"periodicidade_dado": {
// 		"id": 2
// 	},
// 	"meio_representacao": {
// 		"id": 2
// 	},
// 	"meio_distribuicao": {
// 		"id": 2
// 	},
// 	"carga": {
// 		"id": 2
// 	}
// }

// Retorna a confirmação da alteração para o id escolhido

// Apagar dado
// DELETE smitgbc031:55360/api/v1/metadados/dados/{id}

// Retorna a confirmação da exclusão para o id escolhido.

// ==========================================================

function GetDados (id) {
  let params = { 'id': id }
  return Api.get(`${RECURSO}/${DADOS}/${MetodosGlobais.createEncodeQuery(params)}`)
};

function PostDados (payload) {
  return Api.post(`${RECURSO}/${DADOS}/`, payload)
};

function PutDados (payload) {
  return Api.put(`${RECURSO}/${DADOS}/${payload.id}`, payload)
};

function DeleteDados (id) {
  let params = { 'id': id }
  return Api.delete(`${RECURSO}/${DADOS}/${MetodosGlobais.createEncodeQuery(params)}`)
};

// Considerações gerais: todos os campos mostrados nos exemplos são obrigados menos os que forem ditos que não são obrigatórios
// Considerações em relação aos possíveis retornos:

// Confirmações:
// 200: Efetuado com sucesso
// 201: Recurso criado com sucesso

// Erros:
// 400: JSON enviado não condiz ao JSON esperado. Pode ter faltado algum atributo obrigatório ou tipo de dado inválido para determinado atributo
// 401 e 403: problemas com autenticação ou privilégios
// 404: recurso não encontrado GET, PUT ou DELETE em algum recurso que não existe
// 409: conflito. Qualquer operação que viole constraints no banco de dados. Ex.: vincular o dado com uma carga que não existe
